<template>
  <div></div>
</template>
<script>
import { COUPON_PROVIDER_BOOKFAIR } from '@/store/types'
export default {
  name: 'AutoTrialReceiveBookfair',
  data() {
    return {
      bookCode: this.$route.params.code
    }
  },
  mounted() {
    console.log(this.bookCode)
    // 혹시 모르니 한번더 null 체크
    if (this.bookCode != null) {
      // 받은 도서코드로 API에서 체험판 발급.
      this.$store
        .dispatch(COUPON_PROVIDER_BOOKFAIR, { bookCode: this.bookCode })
        .then((res) => {
          if (res.data.ok) {
            this.$router.push({ name: 'library_default' })
          }
        })
        .catch((err) => {
          if (err) {
            alert(err.response.data.errorState.message)
            this.$router.push({
              name: 'library_default'
            })
          }
        })
    } else {
      console.log('null!!')
    }
  },
  method: {}
  /**
   * 해당 페이지에서 이루어져야 하는 내용.
   *
   * 1. QR코드를 찍으면 이 페이지로 들어올 수 있도록 router path 설정.
   * 2. 사용자 로그인 상태 확인. 필요 시 로그인 페이지로 변경.
   * 3. url path 및 params에 따라서 처리 분기
   * 4. 각 변수 값에 맞는 체험판 쿠폰 수령 및 내서재로 이동.
   * 5. 해당 쿠폰 수령 완료 수 카운트
   */
}
</script>
<style lang="scss" scoped></style>
